module.exports = __webpack_public_path__ + "static/media/ruby_logo.cb75cc00.png";